// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"299":"11f9685f803f676ff066","886":"e92a16056bf9e1c0128c"}[chunkId] + ".bundle.js";
};